import BaseService from './baseService';

export default class LookupsService extends BaseService {
    constructor() {
        super('lookups');
    }

    /**
     * Gets all projects in lookup format
     * @returns list of project like [{id: number, displayName: string, sort: number}]
     */
    getProjects = () => this.httpGetRequest('projectList');

    /**
     * Gets all user roles
     * @returns list of user role like [{id: number, displayName: string, sort: number}]
     */
    getUserRoles = () => this.httpGetRequest('userRolesList');

    /**
     * Gets all project codes
     * @returns list of project code lookups
     */
    getProjectCodes = () => this.httpGetRequest('projectCodesList');

    /**
     * Gets the releases.
     * @param {number | undefined} taskId - optional task id
     * @returns List of releases
     */
    getReleases = (taskId?: number | null) => this.httpGetRequest(`releases/${taskId ?? ''}`);

    /**
     * Gets the market models.
     * @param {string} releaseId 
     * @returns list of mm
     */
    getMarketModels = (releaseId: number | string) => this.httpGetRequest(`marketModels/${releaseId}`);

    /**
     * Gets the cube templates.
     * @param {number | null} taskId - task id 
     * @returns list of cube templates
     */
    getCubeTemplates = (taskId: number | null) => this.httpGetRequest(`cubeTemplates/${taskId || ''}`);

    /**
     * Gets the vm sizes.
     * @returns list of vm sizes.
     */
    getVmSizes = () => this.httpGetRequest('vmSizes');

    /**
     * Gets the partition modes.
     * @returns list of partition modes
     */
    getPartitioningModes = () => this.httpGetRequest('partitioningModes');

    /**
     * Gets the time units.
     * @returns list of time units.
     */
    getTimeUnits = () => this.httpGetRequest('timeUnits');

    /**
     * Gets the static report templates.
     * @param {number | null} taskId - task id 
     * @returns list of static report templates.
     */
    getReportTemplates = (taskId: number | null) => this.httpGetRequest(`reportTemplates/${taskId || ''}`);

    /**
     * Gets the static reports.
     * @param {numer} taskId - task id
     * @returns list of static reports.
     */
    getReportingLookup = (taskId: number) => this.httpGetRequest(`reportingLookup/${taskId}`);

    /**
     * Gets the aggregation scopes.
     * @returns list of aggregation scopes.
     */
    getScopes = () => this.httpGetRequest('scopes');

    /**
     * Gets the libraries.
     * @param {number} taskId - task id
     * @returns list of libraries.
     */
    getLibraries = (taskId: number) => this.httpGetRequest(`libraries/${taskId}`);

    getVMGroups = () => this.httpGetRequest('vmGroups');

    /**
     * Gets all SOM modes
     * @returns list of SOM modes
     */
    getSOMModes = () => this.httpGetRequest('somModes');

    /**
     * Gets all SOM releases
     * @returns list of SOM releases
     */
    getSOMReleases = () => this.httpGetRequest('somReleases');

    /**
     * Gets release groups
     * @param {number | null} releaseGroupId - optional release Group Id
     * @returns list of release groups
     */
    getTaskReleaseGroups = (releaseGroupId?: number | null) => this.httpGetRequest(`release-groups?${releaseGroupId}`);

    /**
     * Gets array of user accounts
     * @returns list of user accounts
     */
    getCustomerAccounts = () => this.httpGetRequest('accounts');

    /**
     * Gets market models v2.
     * @param filters Filters for new market models
     */
    getMarketModelsV2 = (filters: {
        ids?: number[];
        pageNumber?: number;
        pageSize?: number;
        names?: string;
    } = {}) => {
        const queryString = this.generateQueryString({
            ids: filters.ids,
            n: filters.names,
            p: filters.pageNumber,
            s: filters.pageSize,
        });

        return this.httpGetRequest(`market-models-v2?${queryString}`);
    };
}
